// The backend owns privacy decisions. Never fall back to a login handle.
export const invitationPlayerLabel = player => player?.display_name || 'Player';
